angular.module('inara').directive('presetButton', function() {
    // Directive defining button for executing preset (lighting, camera, etc.)
    return {
        restrict: 'E',
        templateUrl: 'presetButton.html',
        scope: {
            getPresetIcon: '<',
            isPresetRunning: '<',
            isPresetSelected: '<',
            isPresetDisabled: '<',
            onSelectPreset: '<',
            preset: '<'
        }
    };
});
